import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=6b7bc536"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"
import style0 from "./avatar.vue?vue&type=style&index=0&id=6b7bc536&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./avatar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports